import React, { useCallback } from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import ColumnLayout from '../../../../components/Layouts/ColumnLayout';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import {PortalSettingsGetSchema} from '../../../../api/DBSchema/PortalSettings';
import twoFALoginScreenImg from '../../../../assets/images/twoFALoginScreen.png';
import twoFaAppQrImg from '../../../../assets/images/twoFaAppQr.png';
import Indentation from '../../../../components/Simple/Indentation';

const pageSchema = PortalSettingsGetSchema.pages.twoStepAuth;
const pageId = pageSchema.pageId;

function PortalSettingsTwoStepAuthentication({
    portalSettingsObject,
    setPortalSettingsData
}) {
    const { t } = useTranslation();

    const pageData = portalSettingsObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setPortalSettingsData([pageId, paramName], value);
    }, [setPortalSettingsData]);

    const isTwoFactorAuth = pageData[pageSchema.isTwoFactorAuth];
    
    return (
        <EditorLayout>
            <SMCCheckbox
                checked={isTwoFactorAuth}
                onChange={e => setPageValue(pageSchema.isTwoFactorAuth, e.target.checked)}
                label={t('SMP.SETTINGS.2FA.ENABLE_2FA')}
                labelPosition="start"
            />
            <Indentation>
                <ColumnLayout spacing="24px">
                    <SMCLabel fontSize="14pt">
                        {t('SMP.SETTINGS.2FA.LINE1')}
                    </SMCLabel>
                    <img style={{ width: '70%' }} src={twoFALoginScreenImg} alt="twoFALoginScreen" />
                    <SMCLabel fontSize="14pt">
                        <i>{t('SMP.SETTINGS.2FA.LINE2')}</i>&nbsp;
                        {t('SMP.SETTINGS.2FA.LINE3')}<sup>{t('SMP.SETTINGS.2FA.ND')}</sup>&nbsp;
                        {t('SMP.SETTINGS.2FA.LINE4')}
                    </SMCLabel>
                    <img src={twoFaAppQrImg} alt="twoFaAppQr" />
                    <SMCLabel fontSize="14pt">
                        {t('SMP.SETTINGS.2FA.LINE5')}
                    </SMCLabel>
                </ColumnLayout>
            </Indentation>
        </EditorLayout>
    )
}

export default PortalSettingsTwoStepAuthentication;